import CONTRATO_UBICACIONES from '@/graphql/querys/administracion/contratos/ubicaciones/contratoUbicaciones.gql';
import AGREGAR_CONTRATO_UBICACION from '@/graphql/mutations/administracion/contratos/contrato/ubicaciones/agregarContratoUbicacion.gql';
import ACTUALIZAR_CONTRATO_UBICACION from '@/graphql/mutations/administracion/contratos/contrato/ubicaciones/actualizarContratoUbicacion.gql';
import BORRAR_CONTRATO_UBICACION from '@/graphql/mutations/administracion/contratos/contrato/ubicaciones/removerContratoUbicacion.gql';

export default {
  methods: {
    async mixRegistrarContratoUbicacion(ubicaciones) {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_UBICACION,
          variables: {
            ubicaciones,
          },
          update: (store, { data: { agregarContratoUbicacion } }) => {
            // Query
            const query = {
              query: CONTRATO_UBICACIONES,
              variables: {
                idContrato: this.idContrato,
              },
            };

            // Agregar contrato ubicacion
            const { contratoUbicaciones } = store.readQuery(query);
            const contratoUbicacionesCopia = contratoUbicaciones.slice();
            contratoUbicacionesCopia.push(...agregarContratoUbicacion);
            // Actualizar la store
            store.writeQuery({
              ...query,
              data: {
                contratoUbicaciones: contratoUbicacionesCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },
    async mixActualizarContratoUbicacion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_UBICACION,
          variables: {
            id: this.ubicacionEditar.id,
            ubicacion: this.ubicacion,
          },
          update: (store, { data: { actualizarContratoUbicacion } }) => {
            // Query
            const query = {
              query: CONTRATO_UBICACIONES,
              variables: {
                idContrato: this.ubicacionEditar.idContrato,
              },
            };

            const data = store.readQuery(query);
            const { contratoUbicaciones } = data;
            const index = contratoUbicaciones.findIndex(
              (ubicacion) => ubicacion.id === this.ubicacionEditar.id
            );
            if (index !== -1) {
              contratoUbicaciones.splice(index, 1, actualizarContratoUbicacion);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },
    async mixBorrarContratoUbicacion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: BORRAR_CONTRATO_UBICACION,
          variables: {
            id: this.ubicacionEditar.id,
          },
          update: (store) => {
            // Query
            const query = {
              query: CONTRATO_UBICACIONES,
              variables: {
                idContrato: this.ubicacionEditar.idContrato,
              },
            };

            const data = store.readQuery(query);
            const { contratoUbicaciones } = data;
            const index = contratoUbicaciones.findIndex(
              (ubicacion) => ubicacion.id === this.ubicacionEditar.id
            );
            if (index !== -1) {
              contratoUbicaciones.splice(index, 1);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },
  },
};
